import {Request} from '~src/httpClient/serverApi/requests/Request';
import {IResult} from '~src/httpClient/serverApi/types/IResponse';
import WebHttpClient from '~src/httpClient/WebHttpClient';

class GetExistingContentMigrationPublicKeysRequest extends Request<{}, ContentMigrationPublicKeysInfo[]> {
  constructor() {
    super('getExistingMaskedContentMigrationInfo', {});
  }
}


class GenerateDestinationCredentialMigrationEncryptionKeysRequest extends Request<{}, ContentMigrationPublicKeysInfo> {
  constructor() {
    super('generateDestinationCredentialMigrationEncryptionKeys', {});
  }
}

class DeleteContentMigrationPublicKeyRequest extends Request<DeleteContentMigrationPublicKeyParams, DeleteContentMigrationPublicKeyResult> {
  constructor(params: DeleteContentMigrationPublicKeyParams) {
    super('deleteContentMigrationByMigrationLuid', params);
  }
}

export interface ContentMigrationPublicKeysInfo extends IResult {
  id: number;
  publicKey: string;
  expirationTime: string;
  migrationLuid: string;
  isDestination: boolean;
  authorizedMigrationRunner: string;
}

interface DeleteContentMigrationPublicKeyResult extends IResult {
  result: boolean;
}

interface DeleteContentMigrationPublicKeyParams {
  migrationLuid: string;
}


export class ContentMigrationAuthorizationApi {
  public static readonly instance = new ContentMigrationAuthorizationApi();

  public getExistingContentMigrationPublicKeys(): Promise<ContentMigrationPublicKeysInfo[]> {
    return WebHttpClient.sendRequest(new GetExistingContentMigrationPublicKeysRequest());
  }

  public generateDestinationCredentialMigrationEncryptionKeys(): Promise<ContentMigrationPublicKeysInfo> {
    return WebHttpClient.sendRequest(new GenerateDestinationCredentialMigrationEncryptionKeysRequest());
  }

  public deleteContentMigrationPublicKey(params: DeleteContentMigrationPublicKeyParams): Promise<DeleteContentMigrationPublicKeyResult> {
    return WebHttpClient.sendRequest(new DeleteContentMigrationPublicKeyRequest(params));
  }
}
